import { getTariffs } from "@/api/tariffs";
import { requestStatus } from "@/services/index";
export default {
  namespaced: true,
  state: {
    tariffs: null,
  },
  getters: {
    tariffs: (state) => state.tariffs,
  },
  mutations: {
    set(state, { type, items }) {
      state[type] = items;
    },
  },
  actions: {
    async fetchTariffs({ commit }) {
      try {
        const response = await getTariffs();
        if (response.status === requestStatus.success) {
          commit("set", { type: "tariffs", items: response.response.data.results });
        }
      } catch (error) {
        console.error("Error fetching tariffs:", error);
      }
    },
  },
};
